(function() {
  let observerInitialized = false;

 window.updateCartShippingEstimate = function() {
    const outputEl = document.getElementById("nr-cart-shipping-output");
    if (!outputEl) return false;

    const days = (window.nrI18n && window.nrI18n.weekdaysShort) ? window.nrI18n.weekdaysShort.split(',') : ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];

    function formatDate(date) {
      return `${days[date.getDay()]} ${String(date.getDate()).padStart(2,'0')}.${String(date.getMonth()+1).padStart(2,'0')}.`;
    }

    function parseDayMonth(str) {
      const parts = str.replace(/\./g, ' ').trim().split(/\s+/);
      if (parts.length < 2) return null;
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      if (!day || !month) return null;
      const now = new Date();
      let date = new Date(now.getFullYear(), month - 1, day);
      if (date.getTime() < now.getTime() - 60 * 86400000) {
        date = new Date(now.getFullYear() + 1, month - 1, day);
      }
      return date;
    }

    const raw = (outputEl.dataset.backinstockDates || '').trim();
    if (raw) {
      const ranges = raw.split('|').map(s => s.trim()).filter(Boolean);
      let best = null;
      ranges.forEach(range => {
        const parts = range.split('-');
        const startDate = parseDayMonth((parts[0] || '').trim());
        const endDate = parseDayMonth((parts[1] || parts[0] || '').trim());
        if (!startDate || !endDate) return;
        if (!best || endDate.getTime() > best.end.getTime()) {
          best = { start: startDate, end: endDate };
        }
      });
      if (best) {
        outputEl.innerText = `${formatDate(best.start)} – ${formatDate(best.end)}`;
        outputEl.dataset.nrDone = '1';
        return true;
      }
      if (ranges.length) {
        outputEl.innerText = ranges[0];
        outputEl.dataset.nrDone = '1';
        return true;
      }
    }

    if (!window.nrDeliveryDate) {
      setTimeout(window.updateCartShippingEstimate, 200);
      return false;
    }
    const result = window.nrDeliveryDate(outputEl.dataset.cutoff, outputEl.dataset.days);
    outputEl.innerText = formatDate(result.delivery);
    outputEl.dataset.nrDone = '1';
    return true;
  };

  // Trigger auf verschiedene Events
  document.addEventListener("shopify:section:load", function(event) {
    setTimeout(window.updateCartShippingEstimate, 150);
  });

  document.addEventListener("cart:updated", function() {
    setTimeout(window.updateCartShippingEstimate, 150);
  });

  // Beobachte nur den Cart-Drawer Container (nicht den ganzen Body!)
  function initObserver() {
    if (observerInitialized) return;

    const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('[id*="cart-drawer"]');
    if (!cartDrawer) return;

    const observer = new MutationObserver(function(mutations) {
      const outputEl = document.getElementById("nr-cart-shipping-output");
      // sprachunabhängig: neu gerenderte Spans tragen das nrDone-Flag noch nicht
      if (outputEl && !outputEl.dataset.nrDone) {
        window.updateCartShippingEstimate();
      }
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });

    observerInitialized = true;
  }

  // Init observer when DOM ready + Erstberechnung unabhängig von Mutationen
  function initAll() {
    initObserver();
    setTimeout(window.updateCartShippingEstimate, 100);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
